import { combineReducers } from "redux";
import sessionReducer from "./session";
import usersReducer from "./users";
import casesReducer from "./cases";
import caseFollowsReducer from "./caseFollows";
import userCaseFollowsReducer from "./userCaseFollows";
import distributionListsReducer from "./distributionLists";
import organizationsReducer from "./organizations";
import officesReducer from "./offices";
import tracksReducer from "./tracks";
import drawerReducer from "./drawer";

const rootReducer = combineReducers({
  session: sessionReducer,
  users: usersReducer,
  cases: casesReducer,
  caseFollows: caseFollowsReducer,
  userCaseFollows: userCaseFollowsReducer,
  distributionLists: distributionListsReducer,
  organizations: organizationsReducer,
  offices: officesReducer,
  tracks: tracksReducer,
  drawer: drawerReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
